import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const genericErrorDefaultVariants = {}
const genericErrorCompoundVariants = []

const genericErrorSlotNames = [
  [
    "contentsLayout",
    "generic_error__contentsLayout"
  ],
  [
    "contentsInnerLayout",
    "generic_error__contentsInnerLayout"
  ],
  [
    "iconLayout",
    "generic_error__iconLayout"
  ],
  [
    "icon",
    "generic_error__icon"
  ],
  [
    "title",
    "generic_error__title"
  ],
  [
    "messageLayout",
    "generic_error__messageLayout"
  ],
  [
    "message",
    "generic_error__message"
  ],
  [
    "actionsLayout",
    "generic_error__actionsLayout"
  ]
]
const genericErrorSlotFns = /* @__PURE__ */ genericErrorSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, genericErrorDefaultVariants, getSlotCompoundVariant(genericErrorCompoundVariants, slotName))])

const genericErrorFn = memo((props = {}) => {
  return Object.fromEntries(genericErrorSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const genericErrorVariantKeys = []
const getVariantProps = (variants) => ({ ...genericErrorDefaultVariants, ...compact(variants) })

export const genericError = /* @__PURE__ */ Object.assign(genericErrorFn, {
  __recipe__: false,
  __name__: 'genericError',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: genericErrorVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, genericErrorVariantKeys)
  },
  getVariantProps
})